import { GenIcon } from '../helpers/IconBase.es.js';

const InboxOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M20.7474 10.4609L20.7428 10.4422L18.1131 3.76012C17.9959 3.38278 17.6467 3.12262 17.2506 3.12262H6.59119C6.19275 3.12262 5.83885 3.38746 5.72635 3.76949L3.26775 10.3836L3.26072 10.4L3.25604 10.4187C3.22557 10.5336 3.21619 10.6507 3.2326 10.7656C3.23025 10.8031 3.22791 10.8406 3.22791 10.8781V19.4539C3.22853 19.8316 3.37886 20.1937 3.64597 20.4608C3.91307 20.7279 4.27517 20.8782 4.65291 20.8789H19.3529C20.1381 20.8789 20.7779 20.239 20.7803 19.4539V10.8781C20.7803 10.8476 20.7803 10.8172 20.7779 10.7914C20.7873 10.6765 20.7779 10.5664 20.7474 10.4609ZM13.8146 9.45309L13.8076 9.82106C13.7888 10.8734 13.0623 11.5812 12.0006 11.5812C11.4826 11.5812 11.0373 11.4148 10.7162 11.0984C10.3951 10.782 10.2193 10.3414 10.2099 9.82106L10.2029 9.45309H5.37947L7.24275 4.92262H16.599L18.5138 9.45309H13.8146ZM5.02557 11.2531H8.71229C9.28182 12.5914 10.4935 13.3812 12.0029 13.3812C12.7928 13.3812 13.5263 13.1609 14.1193 12.7437C14.6396 12.3781 15.0451 11.8672 15.3076 11.2531H18.9756V19.0789H5.02557V11.2531Z",
          fill: "#F5222D"
        }
      }
    ]
  })(props);
};

export { InboxOutlined };
